namespace GeniuzPOS.AdvPromo {
    export interface Report_Adv01Form {
        ShopName: Serenity.StringEditor;
        PromoCampaign: Serenity.StringEditor;
        PmGroupId: Serenity.StringEditor;
        PmId: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        PluShortDesc: Serenity.StringEditor;
        SalesQty: Serenity.DecimalEditor;
        SalesAmtBeforePromo: Serenity.DecimalEditor;
        PromoDisc: Serenity.DecimalEditor;
        SalesAmtAfterPromo: Serenity.DecimalEditor;
    }

    export class Report_Adv01Form extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.Report_Adv01';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_Adv01Form.init)  {
                Report_Adv01Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DecimalEditor;

                Q.initFormType(Report_Adv01Form, [
                    'ShopName', w0,
                    'PromoCampaign', w0,
                    'PmGroupId', w0,
                    'PmId', w0,
                    'PluCode', w0,
                    'PluShortDesc', w0,
                    'SalesQty', w1,
                    'SalesAmtBeforePromo', w1,
                    'PromoDisc', w1,
                    'SalesAmtAfterPromo', w1
                ]);
            }
        }
    }
}
